<template>
  <component 
    v-if="cellInfo.type !== 'template'"
    v-bind:is="currCell"
    :cell-data="cellInfo"
    :doc-data="docData"
  />
</template>

<script>
export default {
  components: {
    'data-cell-common': () => import('./DataCellCommon'),
    'data-cell-icon': () => import('./DataCellIcon'),
    'data-cell-image': () => import('./DataCellImage'),
    'data-cell-date': () => import('./DataCellDate'),
    'data-cell-complex': () => import('./DataCellComplex'),
    'data-cell-link': () => import('./DataCellLink')
  },

  props:{
    docData: {
      type: Object,
      required: true
    },
    cellInfo: {
      type: Object,
      required: true
    }
  },

  computed: {
    currCell: function() {
      return `data-cell-${this.cellInfo.type}`
    },

  },
}
</script>